<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-bulk-generate-fail-dialog"
        top="15vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
    >
        <template slot="title">自動產生錯誤</template>

        <div class="detail-row">
            <el-table :data="datas">
                <el-table-column prop="sno" label="單號" width="80">
                    <template slot-scope="scope">
                        <div>{{ scope.row.sno }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="errorMessage" label="原因">
                    <template slot-scope="scope">
                        <div>{{ scope.row.errorMessage }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        datas: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        onBeforeClose() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.accounting-bulk-generate-fail-dialog {
    > .el-dialog {
        max-width: 1100px;
    }
}
</style>
